import currencyListOfSelectorFamily from './selectorFamily';

export default currencyListOfSelectorFamily;
